<template>
  <v-card class="mt-8">
    <v-card-title class="card-title-variations">
      Variações
      <p class="texto-corrido ml-3 mt-4">(Sobrescreve as variações do produto)</p>
    </v-card-title>
    <v-row class="px-8">
      <v-divider></v-divider>
    </v-row>
    <v-card-text class="card-variations">
      <v-row v-for="(variation, index) in productForms.variations" :key="index">
        <v-col cols="4">
          <v-text-field
            v-model="variation.name"
            label="Nome"
            outlined
            color="#C3C8CD"
            height="44px"
            :disabled="!userHasPermission"
            :error="validation.product.variations.$each.length && validation.product.variations.$each[index].name.$error"
            :error-messages="variationError(index)"
          />
        </v-col>
        <v-col cols="2">
          <v-text-field
            v-model="variation.percentage"
            label="Valor percentual"
            hint="X% do preço original"
            outlined
            color="#C3C8CD"
            type="number"
            min="0"
            suffix="%"
            height="44px"
            :disabled="!userHasPermission"
            :error="validation.product.variations.$each.length && validation.product.variations.$each[index].percentage.$error"
            :error-messages="percentageError(index)"
            @keydown="$event.key === '-' || $event.key === '+' || $event.key === 'e' ? $event.preventDefault() : null"
          />
        </v-col>
        <v-col class="py-0 pl-10" cols="3">
          <v-checkbox
            v-model="variation.isDefault"
            label="Trazer selecionado"
            :disabled="!userHasPermission"
            :error="validation.product.variations.$each.length && !validation.product.variations.$each[index].isDefault"
            :error-messages="isDefaultError(index)"
            @change="removeDefault(index)"
          />
        </v-col>
        <v-col class="d-flex justify-end" cols="3">
          <mf-button label="Excluir variação" icon="delete" text color="vermelho-d20" outlined :disabled="!userHasPermission" @click="removeVariation(index)" />
        </v-col>
      </v-row>
      <v-divider v-if="productForms.variations && productForms.variations.length" />
      <v-card-actions>
        <mf-button text color="marca-0-l40" icon="add" label="Adicionar nova variação" :disabled="!userHasPermission" @click="addNewVariation" />
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
const defaultVariation = {
  name: '',
  percentage: '',
  isDefault: false,
}

export default {
  name: 'ProductVariations',
  inject: ['userHasPermission'],
  components: {},
  props: {
    value: {
      type: Object,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    variations: [
      {
        name: '',
        percentage: '',
        isDefault: false,
      },
    ],
  }),
  computed: {
    productForms: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {},
  mounted() {},
  methods: {
    addNewVariation() {
      this.productForms.variations.push({ ...defaultVariation })
    },
    removeVariation(index) {
      this.productForms.variations.splice(index, 1)
    },
    variationError(index) {
      if (
        !!this.validation.product.variations.$each &&
        !!this.validation.product.variations.$each[index].name &&
        this.validation.product.variations.$each[index].name.$error
      ) {
        if (!this.validation.product.variations.$each[index].name.maxLength) {
          return 'Deve conter no máximo 30 caracteres'
        }

        return 'Campo obrigatório'
      }

      return ''
    },
    percentageError(index) {
      if (
        !!this.validation.product.variations.$each &&
        !!this.validation.product.variations.$each[index].percentage &&
        this.validation.product.variations.$each[index].percentage.$error
      ) {
        if (!this.validation.product.variations.$each[index].percentage.minValue) {
          return 'Valor percentual deve ser maior que 0'
        }
        if (!this.validation.product.variations.$each[index].percentage.maxLength) {
          return 'Deve conter no máximo 8 caracteres'
        }
        return 'Campo obrigatório'
      }

      return ''
    },
    isDefaultError(index) {
      if (!!this.validation.product.variations.$each && !this.validation.product.variations.$each[index].isDefault) {
        return 'Selecione uma variação por padrão'
      }

      return ''
    },
    removeDefault(number) {
      this.productForms.variations.forEach((variation, index) => {
        if (index !== number) {
          variation.isDefault = false
        }
      })
    },
  },
}
</script>

<style lang="scss">
.card-variations {
  .v-input,
  .v-input input,
  .v-input textarea,
  .v-select .v-select__selection--comma {
    color: $cinza-0;
  }

  .v-text-field--filled > .v-input__control > .v-input__slot,
  .v-text-field--full-width > .v-input__control > .v-input__slot,
  .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 0 !important;
  }

  .v-text-field--outlined .v-label {
    top: 12px !important;
  }

  .v-label--active {
    top: 18px !important;
    color: $marca-0 !important;
  }

  .v-text-field--enclosed .v-input__append-inner,
  .v-text-field--enclosed .v-input__append-outer,
  .v-text-field--enclosed .v-input__prepend-inner,
  .v-text-field--enclosed .v-input__prepend-outer,
  .v-text-field--full-width .v-input__append-inner,
  .v-text-field--full-width .v-input__append-outer,
  .v-text-field--full-width .v-input__prepend-inner,
  .v-text-field--full-width .v-input__prepend-outer {
    margin-top: 11px;
  }

  .button-delete {
    border: 1px solid #e03211 !important;
  }

  .unset-capitalize {
    text-transform: unset !important;
    letter-spacing: $letterspacing-1;
  }
}
</style>
